<div class="container">
  <h1>404 - Not Found</h1>
  <p>{{'NOT_FOUND_404'|translate}}</p>
</div>